import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { MaskRequest, MaskResponse, ApiError } from '../types/showcase';

/**
 * Mutation: POST /api/eraf/showcase/mask
 * p95 target < 50ms.
 */
export function useMaskDemo() {
  return useMutation<MaskResponse, ApiError, MaskRequest>({
    mutationFn: (req) => showcaseApi.mask(req),
    mutationKey: ['common-showcase', 'mask'],
  });
}
